module.exports = __webpack_public_path__ + "img/_DSC1287.854f665f.jpg";